import { call, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import * as ga from '../redux/actions/app';

import {
  GET_SCORE_EXPLAINABLITY,
  getScoreExplainablitySuccess,
  getScoreExplainablityFail,
  getAMLSTMCommonTransactionHistorySuccess,
  getAMLSTMCommonTransactionHistoryFail,
  GET_AMLS_TM_COMMON_TRANSACTION_HISTORY,
  getAMLSTMCommonTransactionTriggeredTypologiesSuccess,
  getAMLSTMCommonTransactionTriggeredTypologiesFail,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES,
  downloadAMLSTMCommonTransactionHistorySuccess,
  downloadAMLSTMCommonTransactionHistoryFail,
  DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY,
  GET_PEER_AND_PROFILE_GRAPH,
  getPeerAndProfileGraphSuccess,
  getPeerAndProfileGraphFail,
  GET_TYPOLOGY_LIST,
  getTypologyListSuccess,
  getTypologyListFail,
  GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID,
  getRiskIndicatorListByTypologyIdSuccess,
  getRiskIndicatorListByTypologyIdFail,
  GET_PREVENTION_SCORE_EXPLAINABLITY,
  getAmlsCommonPreventionScoreExplainablitySuccess,
  getAmlsCommonPreventionScoreExplainablityFail,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS,
  getAMLSTMCommonTransactionTriggeredVariantsSuccess,
  getAMLSTMCommonTransactionTriggeredVariantsFail,
  GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
  getAMLSTMCommonCustomerLoanDetailsSuccess,
  getAMLSTMCommonCustomerLoanDetailsFail,
  DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
  downloadAMLSTMCommonCustomerLoanDetailsFail,
  downloadAMLSTMCommonCustomerLoanDetailsSuccess,
  GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER,
  getAMLSTMCommonTransactionTypesFilterSuccess,
  getAMLSTMCommonTransactionTypesFilterFail,
  GET_AMLS_TM_COMMON_ACTIVITY_INFORMATION,
  getAMLSTMCommonActivityInfoSuccess,
  getAMLSTMCommonActivityInfoFail,
  DOWNLOAD_AMLS_TM_COMMON_ACTIVITY_INFORMATION,
  downloadAMLSTMCommonActivityInfoSuccess,
  downloadAMLSTMCommonActivityInfoFail,
  GET_AMLS_TM_COMMON_QUERY_FIELDS,
  getAMLSTMCommonQueryFieldsSuccess,
  getAMLSTMCommonQueryFieldsFail,
  GET_FRAML_ALERT_EVENTS,
  GET_ALERT_SCORE_EXPLANATION,
  getFramlAlertEventsSuccess,
  getFramlAlertEventsFail,
  GET_FRAML_ALERT_SCENARIOS,
  getFramlAlertScenariosSuccess,
  getFramlAlertScenariosFail,
  GET_FRAML_RELATED_CASES,
  getFramlRelatedCasesSuccess,
  getFramlRelatedCasesFail,
  getAlertScoreExplanationSuccess,
  getAlertScoreExplanationFail
} from '../redux/actions/tmCommon';
import * as api from '../services/tmCommon';
import * as queryAPI from '../services/common';
import { formatQueryFields } from '../pages/trm/trmUtil';
import { notification } from 'antd';
import { showExportReadyNotification } from '../pages/common/components/ExportReadyNotification';

const networkLayerObject = new api.NetworkLayer();
const networkLayerQueryObject = new queryAPI.NetworkLayer();

function* amlsTMCommonTransactionHistory(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonTransactionHistoryAPI,
      payload
    );

    yield put(getAMLSTMCommonTransactionHistorySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    if (axios.isCancel(error)) {
      yield put(ga.fetchSuccess());
      return;
    }
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonTransactionHistoryFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionHistory() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_TRANSACTION_HISTORY,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionHistory, payload);
    }
  );
}

// FIN-13443 — `onSuccess` is a caller-supplied completion hook (Download History
// refresh). It is stripped before the API call and invoked only after the
// submission succeeded, so the refetch can never race the BE job-row write.
function* amlsTMCommonTransactionHistoryDownload({ onSuccess, ...payload }) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonDownloadTransactionHistoryAPI,
      payload
    );

    if (payload.downloadAll) {
      if (response?.isExisting && response?.status === 'COMPLETED') {
        showExportReadyNotification(response, {});
      } else {
        notification.info({
          message: 'Export In Progress',
          description:
            response?.message ||
            "Your export is being prepared. You will be notified when it's ready."
        });
      }
    }

    yield put(downloadAMLSTMCommonTransactionHistorySuccess(response));
    yield put(ga.fetchSuccess());
    if (typeof onSuccess === 'function') onSuccess(response);
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(downloadAMLSTMCommonTransactionHistoryFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionHistoryDownload() {
  yield takeEvery(
    DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionHistoryDownload, payload);
    }
  );
}

function* amlsTMCommonTransactionTriggeredTypologies(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonTransactionTriggeredTypologiesAPI,
      payload
    );

    yield put(getAMLSTMCommonTransactionTriggeredTypologiesSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonTransactionTriggeredTypologiesFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionTriggeredTypologies() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionTriggeredTypologies, payload);
    }
  );
}

function* amlsTMCommonTransactionTriggeredVariants(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonVariantsListForAlertIdAPI,
      payload
    );

    yield put(
      getAMLSTMCommonTransactionTriggeredVariantsSuccess(
        response,
        payload?.eventType
      )
    );
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(
      getAMLSTMCommonTransactionTriggeredVariantsFail(
        { error },
        payload?.eventType
      )
    );
  }
}

export function* watchAMLSTMCommonTransactionTriggeredVariants() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionTriggeredVariants, payload);
    }
  );
}

function* amlsTMCommonScoreExplainablity(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonScoreExplainabilityAPI,
      payload
    );
    yield put(getScoreExplainablitySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getScoreExplainablityFail({ error }));
  }
}

export function* watchTMCommonScoreExplainablity() {
  yield takeEvery(GET_SCORE_EXPLAINABLITY, function* ({ payload }) {
    yield fork(amlsTMCommonScoreExplainablity, payload);
  });
}

function* amlsPreventionCommonScoreExplainablity(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.preventionCommonScoreExplainabilityAPI,
      payload
    );
    yield put(getAmlsCommonPreventionScoreExplainablitySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAmlsCommonPreventionScoreExplainablityFail({ error }));
  }
}

export function* watchPreventionCommonScoreExplainablity() {
  yield takeEvery(GET_PREVENTION_SCORE_EXPLAINABLITY, function* ({ payload }) {
    yield fork(amlsPreventionCommonScoreExplainablity, payload);
  });
}

function* amlsTMCommonPeerAndProfileGraph(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonPeerAndProfileGraphAPI,
      payload
    );
    yield put(getPeerAndProfileGraphSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getPeerAndProfileGraphFail({ error }));
  }
}

export function* watchTMCommonPeerAndProfileGraph() {
  yield takeEvery(GET_PEER_AND_PROFILE_GRAPH, function* ({ payload }) {
    yield fork(amlsTMCommonPeerAndProfileGraph, payload);
  });
}

function* amlsTMCommonTypologyList(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonTypologyListAPI,
      payload
    );
    yield put(getTypologyListSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getTypologyListFail({ error }));
  }
}

export function* watchTMTyplologyList() {
  yield takeEvery(GET_TYPOLOGY_LIST, function* ({ payload }) {
    yield fork(amlsTMCommonTypologyList, payload);
  });
}

function* amlsTMCommonRiskIndicatorList(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonRiskIndicatorListAPI,
      payload
    );
    yield put(getRiskIndicatorListByTypologyIdSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getRiskIndicatorListByTypologyIdFail({ error }));
  }
}

export function* watchTMRiskIndicatorList() {
  yield takeEvery(
    GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID,
    function* ({ payload }) {
      yield fork(amlsTMCommonRiskIndicatorList, payload);
    }
  );
}

function* amlsTMCommonCustomerLoanDetails(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsTMCommonCustomerLoanDetailsAPI,
      payload
    );
    yield put(getAMLSTMCommonCustomerLoanDetailsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonCustomerLoanDetailsFail({ error }));
  }
}

export function* watchAMLSTMCommonCustomerLoanDetails() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
    function* ({ payload }) {
      yield fork(amlsTMCommonCustomerLoanDetails, payload);
    }
  );
}

function* downloadAmlsTMCommonCustomerLoanDetails(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsTMCommonCustomerLoanDetailsAPI,
      payload
    );
    yield put(downloadAMLSTMCommonCustomerLoanDetailsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(downloadAMLSTMCommonCustomerLoanDetailsFail({ error }));
  }
}

export function* watchDownloadAMLSTMCommonCustomerLoanDetails() {
  yield takeEvery(
    DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
    function* ({ payload }) {
      yield fork(downloadAmlsTMCommonCustomerLoanDetails, payload);
    }
  );
}

function* amlsTMCommonTransactionTypesFilter(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonTransactionTypesFilterAPI,
      payload
    );
    yield put(getAMLSTMCommonTransactionTypesFilterSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonTransactionTypesFilterFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionTypesFilter() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_TRANSACTION_TYPES_FILTER,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionTypesFilter, payload);
    }
  );
}

function* amlsTMCommonActivityInformation(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsTMCommonActivityInformationAPI,
      payload
    );

    yield put(getAMLSTMCommonActivityInfoSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonActivityInfoFail({ error }));
  }
}

export function* watchAMLSTMCommonActivityInformation() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_ACTIVITY_INFORMATION,
    function* ({ payload }) {
      yield fork(amlsTMCommonActivityInformation, payload);
    }
  );
}

// FIN-13443 — same `onSuccess` contract as the Transaction worker above.
function* downloadAMLSTMCommonActivityInformation({ onSuccess, ...payload }) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsTMCommonDownloadActivityInformationAPI,
      payload
    );

    // FIN-11542 — mirror the Transaction-tab toast handling EXACTLY
    // (amlsTMCommonTransactionHistoryDownload above). The toast applies only to
    // the "Download All Matching" (queued async job) path; "Download Current
    // Page" returns an immediate CSV file (no job, no toast).
    if (payload.downloadAll) {
      if (response?.isExisting && response?.status === 'COMPLETED') {
        showExportReadyNotification(response, {});
      } else {
        notification.info({
          message: 'Export In Progress',
          description:
            response?.message ||
            "Your export is being prepared. You will be notified when it's ready."
        });
      }
    }

    yield put(downloadAMLSTMCommonActivityInfoSuccess(response));
    yield put(ga.fetchSuccess());
    if (typeof onSuccess === 'function') onSuccess(response);
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(downloadAMLSTMCommonActivityInfoFail({ error }));
  }
}

export function* watchDownloadAMLSTMCommonActivityInformation() {
  yield takeEvery(
    DOWNLOAD_AMLS_TM_COMMON_ACTIVITY_INFORMATION,
    function* ({ payload }) {
      yield fork(downloadAMLSTMCommonActivityInformation, payload);
    }
  );
}

function* getAMLSTMCommonQueryFields(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerQueryObject.amlsCommonQueryFieldsAPI,
      payload
    );
    const fields = formatQueryFields(response);

    yield put(getAMLSTMCommonQueryFieldsSuccess(fields));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonQueryFieldsFail({ error }));
  }
}

export function* watchAMLSTMCommonQueryFields() {
  yield takeEvery(GET_AMLS_TM_COMMON_QUERY_FIELDS, function* ({ payload }) {
    yield fork(getAMLSTMCommonQueryFields, payload);
  });
}

function* fetchAlertScoreExplanation(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.alertScoreExplanationAPI,
      payload
    );
    yield put(getAlertScoreExplanationSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAlertScoreExplanationFail({ error }));
  }
}

export function* watchAlertScoreExplanation() {
  yield takeEvery(GET_ALERT_SCORE_EXPLANATION, function* ({ payload }) {
    yield fork(fetchAlertScoreExplanation, payload);
  });
}

// FIN-11304 / BE-1 — FRAML-P alert event sequence (Spatial timeline).
function* fetchFramlAlertEvents(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.framlAlertEventsAPI,
      payload
    );
    yield put(getFramlAlertEventsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getFramlAlertEventsFail({ error }));
  }
}

export function* watchFramlAlertEvents() {
  yield takeEvery(GET_FRAML_ALERT_EVENTS, function* ({ payload }) {
    yield fork(fetchFramlAlertEvents, payload);
  });
}

// FIN-11304 / FIN-12857 — scenarios for the timeline's scenario selector.
function* fetchFramlAlertScenarios(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.framlAlertScenariosAPI,
      payload
    );
    yield put(getFramlAlertScenariosSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getFramlAlertScenariosFail({ error }));
  }
}

export function* watchFramlAlertScenarios() {
  yield takeEvery(GET_FRAML_ALERT_SCENARIOS, function* ({ payload }) {
    yield fork(fetchFramlAlertScenarios, payload);
  });
}

// FIN-11304 / BE-3 — related cases for the Spatial "Related Cases" tab.
function* fetchFramlRelatedCases(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.framlRelatedCasesAPI,
      payload
    );
    yield put(getFramlRelatedCasesSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getFramlRelatedCasesFail({ error }));
  }
}

export function* watchFramlRelatedCases() {
  yield takeEvery(GET_FRAML_RELATED_CASES, function* ({ payload }) {
    yield fork(fetchFramlRelatedCases, payload);
  });
}
